.forecast-cell {
    width: 23px; /* for 15 cells, 23px width perfectly fits the modal width including padding*/
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
}
